<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-sys__menu">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm">
        <el-row>
          <el-col :span="5">
            <el-form-item :label="$t('menu.sysCode')"
                          prop="sysCode">
              <el-select v-model="dataForm.sysCode"
                         :placeholder="$t('menu.sysCode')"
                         clearable>
                <el-option v-for="(item,index) in sysCodeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4"
                  class="fr">
            <el-button style="margin-bottom: 7px"
                       class="M-search"
                       @click="query()"
                       type="primary">{{ $t('query') }}</el-button>
            <el-button class="el-back M-search M-margin-l"
                       type="info"
                       @click="reset()">{{ $t('reset') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn-left">
        <el-button type="primary"
                   @click="addUpdate()">{{ $t('add') }}</el-button>
      </div>
      <el-table v-loading="dataListLoading"
                :data="dataList"
                row-key="menuId"
                border
                style="width: 100%;"
                lazy
                :load="getChildList"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="name"
                         :label="$t('menu.name')"
                         header-align="center"
                         width="150"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sysCode"
                         :label="$t('menu.sysCode')"
                         align="center"
                         :formatter="getSysCode"></el-table-column>
        <el-table-column prop="icon"
                         :label="$t('menu.icon')"
                         align="center">
          <template slot-scope="scope">
            <svg class="icon-svg"
                 aria-hidden="true">
              <use :xlink:href="`#${scope.row.icon}`"></use>
            </svg>
          </template>
        </el-table-column>
        <el-table-column prop="type"
                         :label="$t('menu.type')"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 0"
                    size="small">{{ $t('menu.type0') }}</el-tag>
            <el-tag v-else-if="scope.row.type === 1"
                    size="small">{{ $t('menu.type1') }}</el-tag>
            <el-tag v-else
                    size="small">{{ $t('menu.type2') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderNum"
                         :label="$t('menu.sort')"
                         align="center"></el-table-column>
        <el-table-column prop="url"
                         :label="$t('menu.url')"
                         header-align="center"
                         align="left"
                         width="150"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="urls"
                         :label="$t('menu.permissions')"
                         header-align="center"
                         align="left"
                         width="150"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('handle')"
                         fixed="right"
                         header-align="center"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('user.operation') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="addUpdate(scope.row)">{{ $t('update') }}</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="deleteHandleModify(scope.row.menuId)">{{ $t('delete') }}</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
// import debounce from 'lodash/debounce'
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      sysCodeArr: _this.enums['sysCode'], // 子系统
      mixinViewModuleOptions: {
        getDataListURL: '/sys/menu/list',
        // activatedIsNeed: true,
        getDataListIsMenu: true,
        deleteURL: '/sys/menu/delete'
      },
      dataForm: {
        sysCode: ''
      }
    }
  },
  methods: {
    // 获取table子系统
    getSysCode(row) {
      return Vue.filter('coverEnum')(row.sysCode, 'sysCode')
    },
    getChildList(tree, treeNode, resolve) {
      this.getTreeChild(tree.menuId, resolve)
    },
    getTreeChild(menuId, resolve) {
      this.$request.get(
        '/sys/menu/getChildrenlist',
        {
          menuId: menuId
        }
      ).then((res) => {
        resolve(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    addUpdate(row) {
      this.$router.push({
        name: 'sys-menu-add-or-update',
        query: {
          menuId: row != null ? row.menuId : undefined
        }
      })
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_MENU, 'activated')
    }
    // deleteHandleModify: debounce(
    //   function (menuId) {
    //     this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
    //       confirmButtonText: this.$t('confirm'),
    //       cancelButtonText: this.$t('cancel')
    //     }).then(() => {
    //       this.$request.delete(
    //         this.mixinViewModuleOptions.deleteURL,
    //         {
    //           menuId: menuId
    //         }
    //       ).then((res) => {
    //         this.$message({
    //           message: this.$t('prompt.success'),
    //           type: 'success',
    //           duration: 500,
    //           onClose: () => {
    //             this.query()
    //           }
    //         })
    //       }).catch(() => { })
    //     }).catch(() => { })
    //   }, 5000, { leading: true, trailing: false }
    // )
  }
}
</script>
<style lang="scss" scoped>
.search {
  margin-bottom: 10px;
}
</style>
